import { createAction, props } from '@ngrx/store';
import { Website, Account, UpsertWebsitePayload } from './interfaces';

export const getWebsitesAction = createAction('[Ecom] Get Websites');
export const getWebsitesSuccessAction = createAction(
  '[Ecom] Get Websites Success',
  props<{ websites: Website[] }>(),
);
export const getWebsitesFailAction = createAction('[Ecom] Get Websites Fail');

export const getAccountsAction = createAction('[Ecom] Get Accounts');
export const getAccountsSuccessAction = createAction(
  '[Ecom] Get Accounts Success',
  props<{ accounts: Account[] }>(),
);
export const getAccountsFailAction = createAction('[Ecom] Get Accounts Fail');

export const upsertWebsiteAction = createAction(
  '[Ecom] Upsert Website',
  props<{ payload: UpsertWebsitePayload }>(),
);
export const upsertWebsiteSuccessAction = createAction(
  '[Ecom] Upsert Website Success',
);
export const upsertWebsiteFailAction = createAction(
  '[Ecom] Upsert Website Fail',
);

export const deleteWebsiteAction = createAction(
  '[Ecom] Delete Website',
  props<{ payload: string }>(),
);
export const deleteWebsiteSuccessAction = createAction(
  '[Ecom] Delete Website Success',
);
export const deleteWebsiteFailAction = createAction(
  '[Ecom] Delete Website Fail',
);
